export default __webpack_public_path__ + "static/videoIntro-720-7760106054396c0bd8e449a55119c194.mp4";